import React, { useState } from "react";
import axios from "axios";

const VerifyCertificate = () => {
  const [code, setCode] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const verifyCertificate = async () => {
    try {
      // const response = await axios.get(`https://localhost:7143/api/certificates/verify/${code}`); //Localhost -- Passed
      // const response = await axios.get(`http://relsofttims-001-site1.gtempurl.com/api/certificates/verify/${code}`); //Cloud with http -- Failed
      const response = await axios.get(`https://relsofttims-001-site1.gtempurl.com/api/certificates/verify/${code}`); 	//Cloud with https --Passed     	
      setData(response.data);
      setError("");
    } catch (err) {
      setData(null);
      
      // Fix: Check if the error has a response object
      if (err.response && err.response.data) {
        setError(err.response.data.message || "An error occurred.");
      } else {
        setError("An unexpected error occurred. Please try again.");
      }
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>Verify Your Certificate</h2>
      
      {/* Input & Button Container */}
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
        <input 
          type="text" 
          placeholder="Enter Verification Code" 
          value={code} 
          onChange={(e) => setCode(e.target.value)} 
          style={{ padding: "10px", fontSize: "16px" }}
        />
        <button onClick={verifyCertificate} style={{ padding: "10px 20px", fontSize: "16px", cursor: "pointer" }}>Verify</button>
      </div>

      {data && (
        <div style={{ marginTop: "20px", border: "1px solid #ddd", padding: "20px", display: "inline-block", textAlign: "left" }}>
          <h3>Certificate Found</h3>
          <p><strong>Name:</strong> {data.name}</p>
          <p><strong>Course Title:</strong> {data.courseTitle}</p>
          <p><strong>Issued Date:</strong> {new Date(data.issuedDate).toLocaleDateString()}</p>
        </div>
      )}

      {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
    </div>
  );
};

export default VerifyCertificate;
